import React from 'react';
import i18n from 'util/i18n';

import { Summary, DateSummary } from 'components/Summary';
import { SUBSTANCE_USE, SUBSTANCE_USE_CONTROLLED_EMPLOYED_ILLEGAL_USAGE } from 'config/formSections/substanceUse';
import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import Comments from 'components/Form/Comments';
import { isPVQForm } from 'helpers/form';
import DrugSupplementalPublicSafetyUse from './DrugSupplementalPublicSafetyUse';

const sectionConfig = {
  key: SUBSTANCE_USE_CONTROLLED_EMPLOYED_ILLEGAL_USAGE.key,
  section: SUBSTANCE_USE.name,
  store: SUBSTANCE_USE.store,
  subsection: SUBSTANCE_USE_CONTROLLED_EMPLOYED_ILLEGAL_USAGE.name,
  storeKey: SUBSTANCE_USE_CONTROLLED_EMPLOYED_ILLEGAL_USAGE.storeKey,
};

export class DrugSupplementalPublicSafety extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.updateList = this.updateList.bind(this);
    this.updateEmployedIllegalControlledSubstanceUseAnswer = this.updateEmployedIllegalControlledSubstanceUseAnswer.bind(this);
    this.updateBranchComment = this.updateBranchComment.bind(this);
    this.updateSummaryComment = this.updateSummaryComment.bind(this);
    this.summary = this.summary.bind(this);
  }

  update = (updateValues) => {
    this.props.onUpdate(this.storeKey, {
      EmployedIllegalControlledSubstanceUseAnswer: this.props.EmployedIllegalControlledSubstanceUseAnswer,
      EmployedIllegalControlledSubstanceUseComment: this.props.EmployedIllegalControlledSubstanceUseComment,
      EmployedIllegalControlledSubstanceUseSummaryComment: this.props.EmployedIllegalControlledSubstanceUseSummaryComment,
      List: this.props.List,
      ...updateValues,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateEmployedIllegalControlledSubstanceUseAnswer = (values) => {
    const additional = values.value === 'Yes' ? {} : {
      List: [],
      EmployedIllegalControlledSubstanceUseSummaryComment: ''
    };
    this.update({
      EmployedIllegalControlledSubstanceUseAnswer: values,
      ...additional
    });
  };

  summary = (item, index) => {
    const o = (item || {}).Item || {};
    const range = DateSummary(o.DateRange);
    const drugUsed = (o.DrugUsed || {}).value;

    return Summary({
      type: i18n.t('substance.drugs.supplementalPublicSafety.collection.itemType'),
      index,
      left: drugUsed,
      right: range,
      placeholder: i18n.t('substance.drugs.supplementalPublicSafety.collection.summary'),
    });
  };

  updateBranchComment = (values) => {
    this.update({
      EmployedIllegalControlledSubstanceUseComment: values,
    });
  };

  updateSummaryComment = (values) => {
    this.update({
      EmployedIllegalControlledSubstanceUseSummaryComment: values,
    });
  };

  render() {
    const { errors } = this.props;

    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);
    const isPvq = isPVQForm(this.props.formType);
    return isPvq ? (
      <div
        className="section-content drug-supplemental-public-safety-uses"
        data-section={SUBSTANCE_USE.key}
        data-subsection={SUBSTANCE_USE_CONTROLLED_EMPLOYED_ILLEGAL_USAGE.key}
      >
        <h1 className="section-header">{i18n.t('substance.pvq.subsection.drugs.supplementalPublicSafety')}</h1>
        <Branch
          attribute="EmployedIllegalControlledSubstanceUseAnswer"
          name="EmployedIllegalControlledSubstanceUseAnswer"
          label={i18n.t('substance.pvq.drugs.heading.supplementalPublicSafety')}
          labelSize="h4"
          className="employed-illegal-controlled-substance-use-answer"
          {...this.props.EmployedIllegalControlledSubstanceUseAnswer}
          warning
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          required={this.props.required}
          onUpdate={this.updateEmployedIllegalControlledSubstanceUseAnswer}
          scrollIntoView={this.props.scrollIntoView}
        />
        <Show when={this.props.EmployedIllegalControlledSubstanceUseAnswer.value === 'Yes'}>
          <Accordion
            attribute="List"
            defaultState={this.props.defaultState}
            {...this.props.List}
            scrollToBottom={this.props.scrollToBottom}
            summary={this.summary}
            onUpdate={this.updateList}
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            errors={accordionErrors}
            description={i18n.t('substance.pvq.drugs.supplementalPublicSafety.collection.description')}
            appendTitle={i18n.t('substance.pvq.drugs.supplementalPublicSafety.collection.appendTitle')}
            appendLabel={i18n.t('substance.pvq.drugs.supplementalPublicSafety.collection.appendLabel')}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
          >
            <DrugSupplementalPublicSafetyUse
              name="Item"
              bind
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              formType={this.props.formType}
            />
          </Accordion>
        </Show>
      </div>
    ) : (
      <div
        className="section-content drug-supplemental-public-safety-uses"
        data-section={SUBSTANCE_USE.key}
        data-subsection={SUBSTANCE_USE_CONTROLLED_EMPLOYED_ILLEGAL_USAGE.key}
      >
        <h1 className="section-header">{i18n.t('substance.subsection.drugs.supplementalPublicSafety')}</h1>
        <Branch
          attribute="EmployedIllegalControlledSubstanceUseAnswer"
          name="EmployedIllegalControlledSubstanceUseAnswer"
          label={i18n.t('substance.drugs.heading.supplementalPublicSafety')}
          labelSize="h4"
          className="employed-illegal-controlled-substance-use-answer"
          {...this.props.EmployedIllegalControlledSubstanceUseAnswer}
          warning
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          required={this.props.required}
          onUpdate={this.updateEmployedIllegalControlledSubstanceUseAnswer}
          scrollIntoView={this.props.scrollIntoView}
        />
        <Comments
          title={i18n.t('substance.drugs.supplementalPublicSafety.heading.branchComment')}
          name="EmployedIllegalControlledSubstanceUseComment"
          className="employed-illegal-controlled-substance-use-comment"
          attribute="EmployedIllegalControlledSubstanceUseComment"
          {...this.props.EmployedIllegalControlledSubstanceUseComment}
          onUpdate={this.updateBranchComment}
          required={false}
        />
        <Show when={this.props.EmployedIllegalControlledSubstanceUseAnswer.value === 'Yes'}>
          <Accordion
            attribute="List"
            defaultState={this.props.defaultState}
            {...this.props.List}
            scrollToBottom={this.props.scrollToBottom}
            summary={this.summary}
            onUpdate={this.updateList}
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            errors={accordionErrors}
            description={i18n.t('substance.drugs.supplementalPublicSafety.collection.description')}
            appendTitle={i18n.t('substance.drugs.supplementalPublicSafety.collection.appendTitle')}
            appendLabel={i18n.t('substance.drugs.supplementalPublicSafety.collection.appendLabel')}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
          >
            <DrugSupplementalPublicSafetyUse
              name="Item"
              bind
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
            />
          </Accordion>
          <Comments
            title={i18n.t('substance.drugs.supplementalPublicSafety.heading.summaryComment')}
            name="EmployedIllegalControlledSubstanceUseSummaryComment"
            className="employed-illegal-controlled-substance-use-summary-comment"
            attribute="EmployedIllegalControlledSubstanceUseSummaryComment"
            {...this.props.EmployedIllegalControlledSubstanceUseSummaryComment}
            onUpdate={this.updateSummaryComment}
            required={false}
          />
        </Show>
      </div>
    );
  }
}

DrugSupplementalPublicSafety.defaultProps = {
  EmployedIllegalControlledSubstanceUseAnswer: {},
  EmployedIllegalControlledSubstanceUseComment: '',
  EmployedIllegalControlledSubstanceUseSummaryComment: '',
  List: { items: [], branch: {} },
  onError: (value, arr) => arr,
  section: 'drugs',
  subsection: 'drugs/supplementalpublicsafety',
  dispatch: () => { },
  scrollToBottom: '',
  errors: [],
  formType: '',
};

export default connectSubsection(DrugSupplementalPublicSafety, sectionConfig);
